import { supabase } from '../clients/supabaseClient';
import type { ParsedOrderLine } from '../lib/parseOrderPdf';

export type MatchedLine = {
    product_id: string;
    sku: string;
    name: string;
    units?: string | null;
    quantity: number;
    unit_price_cents: number;
    line_total_cents: number;
    product_prices_id: string;
    line_number: number;
};

export type SkippedLine = {
    code: string;
    description: string;
};

export type PriceChange = {
    sku: string;
    name: string;
    old_price_cents: number;
    new_price_cents: number;
};

export type ReconcileOrderPdfResult = {
    matched: MatchedLine[];
    skipped: SkippedLine[];
    price_changes: PriceChange[];
};

export async function reconcileOrderPdf(
    storeId: string,
    lines: ParsedOrderLine[]
): Promise<ReconcileOrderPdfResult> {
    const { data, error } = await supabase.functions.invoke('reconcile-order-pdf', {
        body: { store_id: storeId, lines },
    });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data as ReconcileOrderPdfResult;
}